module.exports = __webpack_public_path__ + "images/microsoft-icons.png";